import DeviceDetector from 'device-detector-js'

export default {
  data () {
    return {
      deviceInfo: {
        isMac: false,
        isIphone: false,
        os: {}
      }
    }
  },
  mounted() {
    this.getDeviceOS()
  },
  methods: {
    getDeviceOS () {
      const detector = new DeviceDetector();
      const device = detector.parse(window.navigator.userAgent);

      this.deviceInfo.os = device.os
      this.deviceInfo.isIphone = device.os.name === "iOS";
      this.deviceInfo.isMac = device.os.name ? device.os.name.toLowerCase().includes("mac") : false
    }
  }
}
